module.exports = __webpack_public_path__ + "img/type999.9d8ea78b.png";